<div class="circles">
  <div
    class="circle"
    *ngFor="let threshold of thresholds"
    [class.circle-active]="(decibels ?? 0) >= (threshold ?? 0)"
  ></div>
</div>
